export const HOME = "/";
export const LOGIN = "/login";
export const DETAIL = "/detail";
